import { render } from "./SubscriptionExpired.vue?vue&type=template&id=f9b45bf8"
import script from "./SubscriptionExpired.vue?vue&type=script&lang=js"
export * from "./SubscriptionExpired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__